// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 20px;
  background-color: #eaedeb;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 15px;
}

.header-title-section {
  display: flex;
  flex-direction: column;
}

.dashboard-title {
  font-family: 'Work Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #294A50;
  margin: 0;
}

.dashboard-subtitle {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.header-actions {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

/* KPI Cards */
.kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;
}

.kpi-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid rgba(0,0,0,0.05);
  transition: transform 0.2s;
}

.kpi-card:hover {
  transform: translateY(-2px);
}

.kpi-label {
  font-size: 12px;
  font-weight: 700;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.kpi-value {
  font-size: 32px;
  font-weight: 800;
  color: #294A50;
}

.kpi-subtext {
  font-size: 12px;
  color: #888;
  margin-top: 5px;
}

.kpi-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0.15;
  font-size: 40px !important;
}

/* Daily Summary Strip */
.daily-strip-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.strip-title {
  font-size: 14px;
  font-weight: 700;
  color: #294A50;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.daily-strip {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 10px;
  scrollbar-width: thin;
}

.daily-strip::-webkit-scrollbar {
  height: 6px;
}

.daily-strip::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.day-card {
  min-width: 110px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
}

.day-card.selected {
  background: #fff;
  border-color: #49758d;
  box-shadow: 0 2px 8px rgba(73, 117, 141, 0.2);
}

.day-date {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 5px;
}

.day-total {
  font-size: 20px;
  font-weight: 800;
  color: #294A50;
  margin-bottom: 5px;
}

.day-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  font-size: 11px;
}

.day-passed { color: #13A13E; font-weight: 600; }
.day-rejected { color: #E25984; font-weight: 600; }
.day-rate { font-size: 12px; font-weight: 700; margin-top: 4px; }

/* Charts Grid */
.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.chart-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  min-height: 380px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-title {
  font-size: 14px;
  font-weight: 700;
  color: #294A50;
  text-transform: uppercase;
}

.chart-content {
  flex: 1 1;
  position: relative;
  min-height: 0;
}

/* Profile Table */
.profile-table-container {
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: auto;
  scrollbar-width: thin;
}

.profile-table-container::-webkit-scrollbar {
  width: 6px;
}

.profile-table-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.scrollable-chart-container {
  overflow-y: auto;
  scrollbar-width: thin;
}

.scrollable-chart-container::-webkit-scrollbar {
  width: 6px;
}

.scrollable-chart-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.profile-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.profile-table th {
  text-align: left;
  padding: 12px 10px;
  border-bottom: 2px solid #f0f0f0;
  color: #777;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
}

.profile-table td {
  padding: 14px 10px;
  border-bottom: 1px solid #f8f8f8;
  color: #294A50;
  font-weight: 500;
}

.reject-rate-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 11px;
  display: inline-block;
}

@media (max-width: 1200px) {
  .kpi-row { grid-template-columns: repeat(2, 1fr); }
  .charts-grid { grid-template-columns: 1fr; }
}

@media (max-width: 600px) {
  .kpi-row { grid-template-columns: 1fr; }
  .dashboard-header { flex-direction: column; align-items: flex-start; }
}

@media print {
  @page {
    size: auto;
    margin: 10mm;
  }
  
  body {
    print-color-adjust: exact;
    background-color: white !important;
  }

  .MuiAppBar-root,
  .header-actions,
  .MuiDrawer-root,
  nav {
    display: none !important;
  }

  .dashboard-container {
    padding: 0 !important;
    background-color: white !important;
    height: auto !important;
    overflow: visible !important;
  }

  .kpi-row,
  .charts-grid {
    page-break-inside: avoid;
  }

  .chart-card {
    box-shadow: none !important;
    border: 1px solid #eee;
    break-inside: avoid;
    page-break-inside: avoid;
    margin-bottom: 20px;
  }

  .scrollable-chart-container {
    overflow: visible !important;
    max-height: none !important;
  }

  .scrollable-chart-container > div {
    height: auto !important;
  }
  
  .profile-table-container {
    overflow: visible !important;
    max-height: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA,cAAc,cAAc,EAAE,gBAAgB,EAAE;AAChD,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;AAClD,YAAY,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEhE,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,eAAe,0BAA0B,EAAE;AAC7C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,oBAAoB,sBAAsB,EAAE,uBAAuB,EAAE;AACvE;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IAEE,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,kCAAkC;IAClC,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF","sourcesContent":[".dashboard-container {\n  padding: 20px;\n  background-color: #eaedeb;\n  min-height: 100vh;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.header-title-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-title {\n  font-family: 'Work Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #294A50;\n  margin: 0;\n}\n\n.dashboard-subtitle {\n  font-size: 13px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.header-actions {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* KPI Cards */\n.kpi-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  width: 100%;\n}\n\n.kpi-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.05);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  border: 1px solid rgba(0,0,0,0.05);\n  transition: transform 0.2s;\n}\n\n.kpi-card:hover {\n  transform: translateY(-2px);\n}\n\n.kpi-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.kpi-value {\n  font-size: 32px;\n  font-weight: 800;\n  color: #294A50;\n}\n\n.kpi-subtext {\n  font-size: 12px;\n  color: #888;\n  margin-top: 5px;\n}\n\n.kpi-icon {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  opacity: 0.15;\n  font-size: 40px !important;\n}\n\n/* Daily Summary Strip */\n.daily-strip-container {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.05);\n}\n\n.strip-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #294A50;\n  margin-bottom: 15px;\n  text-transform: uppercase;\n}\n\n.daily-strip {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 10px;\n  scrollbar-width: thin;\n}\n\n.daily-strip::-webkit-scrollbar {\n  height: 6px;\n}\n\n.daily-strip::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n\n.day-card {\n  min-width: 110px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.day-card.selected {\n  background: #fff;\n  border-color: #49758d;\n  box-shadow: 0 2px 8px rgba(73, 117, 141, 0.2);\n}\n\n.day-date {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 5px;\n}\n\n.day-total {\n  font-size: 20px;\n  font-weight: 800;\n  color: #294A50;\n  margin-bottom: 5px;\n}\n\n.day-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: center;\n  font-size: 11px;\n}\n\n.day-passed { color: #13A13E; font-weight: 600; }\n.day-rejected { color: #E25984; font-weight: 600; }\n.day-rate { font-size: 12px; font-weight: 700; margin-top: 4px; }\n\n/* Charts Grid */\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.chart-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.05);\n  display: flex;\n  flex-direction: column;\n  min-height: 380px;\n}\n\n.chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.chart-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #294A50;\n  text-transform: uppercase;\n}\n\n.chart-content {\n  flex: 1;\n  position: relative;\n  min-height: 0;\n}\n\n/* Profile Table */\n.profile-table-container {\n  width: 100%;\n  max-height: 300px;\n  overflow-y: auto;\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n\n.profile-table-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.profile-table-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n\n.scrollable-chart-container {\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n\n.scrollable-chart-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scrollable-chart-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n\n.profile-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.profile-table th {\n  text-align: left;\n  padding: 12px 10px;\n  border-bottom: 2px solid #f0f0f0;\n  color: #777;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 11px;\n}\n\n.profile-table td {\n  padding: 14px 10px;\n  border-bottom: 1px solid #f8f8f8;\n  color: #294A50;\n  font-weight: 500;\n}\n\n.reject-rate-badge {\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 11px;\n  display: inline-block;\n}\n\n@media (max-width: 1200px) {\n  .kpi-row { grid-template-columns: repeat(2, 1fr); }\n  .charts-grid { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 600px) {\n  .kpi-row { grid-template-columns: 1fr; }\n  .dashboard-header { flex-direction: column; align-items: flex-start; }\n}\n\n@media print {\n  @page {\n    size: auto;\n    margin: 10mm;\n  }\n  \n  body {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n    background-color: white !important;\n  }\n\n  .MuiAppBar-root,\n  .header-actions,\n  .MuiDrawer-root,\n  nav {\n    display: none !important;\n  }\n\n  .dashboard-container {\n    padding: 0 !important;\n    background-color: white !important;\n    height: auto !important;\n    overflow: visible !important;\n  }\n\n  .kpi-row,\n  .charts-grid {\n    page-break-inside: avoid;\n  }\n\n  .chart-card {\n    box-shadow: none !important;\n    border: 1px solid #eee;\n    break-inside: avoid;\n    page-break-inside: avoid;\n    margin-bottom: 20px;\n  }\n\n  .scrollable-chart-container {\n    overflow: visible !important;\n    max-height: none !important;\n  }\n\n  .scrollable-chart-container > div {\n    height: auto !important;\n  }\n  \n  .profile-table-container {\n    overflow: visible !important;\n    max-height: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
